import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
const CARDS = [{
  titulo: 'Un Paraíso Sagrado',
  texto: 'Bali es el lugar donde la naturaleza y el espíritu se funden en una sola respiración. Cada rincón vibra con una energía que despierta lo que duerme en ti.'
}, {
  titulo: 'Ubud, Corazón Espiritual',
  texto: 'Escenario de rituales ancestrales y sanación profunda, Ubud te invita a soltar todo lo que ya no eres y abrazar todo lo que siempre fuiste.'
}, {
  titulo: 'Tu Renacimiento',
  texto: 'Aquí comienza tu viaje hacia el amor propio, la renovación total y el reencuentro con tu divinidad más auténtica.'
}];
export function Isla() {
  return <section id="isla" className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-129">
      <div className="mx-auto max-w-7xl" data-id="element-130">
        <SectionHeading eyebrow="La Isla de los Dioses" title="La Magia de Bali: Naturaleza, Espíritu y Transformación" subtitle="Bali es donde la naturaleza y el espíritu se funden en una sola respiración." data-id="element-131" />

        <div className="mt-16 grid gap-6 md:grid-cols-3" data-id="element-132">
          {CARDS.map((card, i) => <Reveal key={card.titulo} delay={i * 0.1} data-id="element-133">
              <article className="h-full rounded-3xl border bg-white/60 p-8 backdrop-blur-sm transition-transform hover:-translate-y-1" style={{
            borderColor: 'rgba(200,153,46,0.25)'
          }} data-id="element-134">
                <span className="font-heading text-5xl font-light" style={{
              color: 'rgba(200,153,46,0.5)'
            }} data-id="element-135">
                  0{i + 1}
                </span>
                <h3 className="mt-5 font-heading text-xl font-normal" style={{
              color: 'var(--ink)'
            }} data-id="element-136">
                  {card.titulo}
                </h3>
                <p className="mt-3 text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-137">
                  {card.texto}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}